import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from 'components/common/FalconCardHeader';
import TableControlBar from 'components/common/table/TableControlBar';
import React, { useRef, useState } from 'react';
import { Button, Card, Offcanvas, Table, Form } from 'react-bootstrap';
import NotaryItem from './NotaryItem';
import NotaryProfileForm from './NotaryProfileForm';
import logger from 'util/logger';
import moment from 'moment';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { refreshUserProfile } from 'stores/app';
import useTableControlPagination from 'hooks/useTableControlPagination';

const statusColumnStyle = {
  width: '4rem',
  minWidth: '4rem'
};

const NotarySettings = props => {
  const [profile, setProfile] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [statusFilter, setStatusFilter] = useState('active'); // all | active | inactive
  const formRef = useRef(null);
  const dispatch = useDispatch();

  const updateProfile = GUID => {
    let uProfile = _.filter(props.userProfile, p => {
      return p.GUID === GUID;
    });
    logger.log('Updating profile', uProfile);
    setCollapsed(true);
    setProfile(uProfile[0]);
  };

  const isProfileActive = profile => {
    return (
      profile?.Active &&
      moment()
        .startOf('day')
        .isSameOrBefore(moment(profile?.ExpirationDate).utc())
    );
  };

  const getDisplayProfiles = () => {
    const profiles = props.userProfile || [];
    const defaults = profiles.filter(p => p?.IsDefault);
    const actives = profiles.filter(p => !p?.IsDefault && isProfileActive(p));
    const inactives = profiles.filter(
      p => !p?.IsDefault && !isProfileActive(p)
    );

    if (statusFilter === 'active') {
      return [...defaults, ...actives];
    }
    if (statusFilter === 'inactive') {
      return inactives;
    }
    // all: default first, then active, then inactives
    return [...defaults, ...actives, ...inactives];
  };

  const displayProfiles = getDisplayProfiles();
  const notaryProfilesTable = useTableControlPagination(displayProfiles, 10);

  return (
    <Card className="mt-3">
      <FalconCardHeader title={null} />
      <Card.Body className="fs--1 bg-light">
        <div ref={formRef}>
          <Offcanvas
            id="offcanvas-notaryProfile-form"
            show={collapsed}
            backdrop="static"
            onHide={() => {
              setCollapsed(!collapsed);
            }}
            placement="end"
            className="offcanvas-half-width"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>{'Notary Profile'}</Offcanvas.Title>
            </Offcanvas.Header>
            <hr className="my-0" />
            <Offcanvas.Body>
              <NotaryProfileForm
                profile={profile}
                setCollapsed={setCollapsed}
              />
            </Offcanvas.Body>
          </Offcanvas>
        </div>

        <TableControlBar
          {...notaryProfilesTable}
          visibleRowCount={notaryProfilesTable.pageRows.length}
          onRefresh={() => dispatch(refreshUserProfile())}
          filters={
            <Form.Select
              aria-label="Filter notary commissions by status"
              size="sm"
              value={statusFilter}
              onChange={e => setStatusFilter(e.target.value)}
              className="w-auto"
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          }
          actions={
            <Button
              size="sm"
              variant="primary"
              onClick={() => {
                setCollapsed(true);
                setProfile(null);
              }}
            >
              <FontAwesomeIcon icon="plus" /> Add
            </Button>
          }
        />

        <Table responsive striped hover>
          <thead>
            <tr>
              <th scope="col">Default</th>
              <th scope="col" style={statusColumnStyle}>
                Status
              </th>
              <th scope="col">Name</th>
              <th scope="col">C Number</th>
              <th scope="col">Address</th>
              <th scope="col">Timezone</th>
              <th scope="col">Expiration</th>
              <th className="text-end" scope="col">
                Actions
              </th>
            </tr>
          </thead>
          {displayProfiles.length ? (
            <tbody>
              {notaryProfilesTable.pageRows.map((item, index, arr) => (
                <NotaryItem
                  key={item.GUID}
                  details={item}
                  isLast={index === arr.length - 1}
                  updateProfile={updateProfile}
                  formRef={formRef}
                />
              ))}
            </tbody>
          ) : (
            <tr>
              <td colSpan={8} scope="col">
                <div className="text-center">
                  <h4>
                    <FontAwesomeIcon name="user" />
                  </h4>
                  <p className="my-3">
                    You haven't created your Notary profile yet.
                  </p>
                  <Button
                    onClick={() => {
                      setCollapsed(!collapsed);
                    }}
                    className="ml-2"
                    color="primary"
                  >
                    Create Notary Profile
                  </Button>
                </div>
              </td>
            </tr>
          )}
        </Table>
      </Card.Body>
    </Card>
  );
};

export default NotarySettings;
